export default __webpack_public_path__ + "41a6357619acea9de3691d220bde5362.svg";